import { type ThunkAction } from "redux-thunk";
import { type RootState } from "../../redux/store";
import { type AnyAction } from "../../redux/types";
import { searchAfterwards } from "../../Search/redux/actions";

export const RESET_SA_FILTERS = "SA: Reset Filters";
export const CHANGE_SA_TAB = "SA: Change Tab";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

function resetSAFiltersAction() {
  return {
    type: RESET_SA_FILTERS,
  };
}

function changeTabAction(tab: string) {
  return {
    type: CHANGE_SA_TAB,
    payload: tab,
  };
}

export function resetSAFilters(): ThunkResult<void> {
  return (dispatch, getState) => {
    dispatch(searchAfterwards(resetSAFiltersAction()));
  };
}

export function changeSATab(tab: string): ThunkResult<void> {
  return (dispatch, getState) => {
    dispatch(changeTabAction(tab));
  };
}
